import { render } from "./OperationRecord.vue?vue&type=template&id=0445857b&scoped=true"
import script from "./OperationRecord.vue?vue&type=script&lang=js"
export * from "./OperationRecord.vue?vue&type=script&lang=js"

import "./OperationRecord.vue?vue&type=style&index=0&id=0445857b&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0445857b"]])

export default __exports__